'use client';
import { useEffect, useState } from 'react';
import { useT } from '../lib/i18n';
import { useLayerLock } from '../lib/useLayerLock';
import { Icon } from './Icon';

/**
 * 약관 레이어 — 푸터의 이용약관·개인정보처리방침이 연다(가이드 layer-popup).
 * 문서는 리치HTML 이라 열 때만 BFF 로 받아 온다(`/api/site/notices?code=`).
 * HTML 은 관리자 저장 시 서버가 sanitize 한 값이다(§16-8) — 그대로 그린다.
 */
export function NoticeLink({ code, className, children }: {
  code: string;
  className?: string;
  children: React.ReactNode;
}) {
  const t = useT();
  const [open, setOpen] = useState(false);
  const [html, setHtml] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!open || html !== undefined) return;
    fetch(`/api/site/notices?code=${code}`)
      .then((r) => r.json())
      .then((d: { html: string | null }) => setHtml(d.html))
      .catch(() => setHtml(null));
  }, [open, html, code]);

  // 스크롤 잠금 + Esc 닫기. **딤 클릭으로는 닫지 않는다**
  useLayerLock(open, () => setOpen(false));

  return (
    <>
      <a href="#" className={className} onClick={(e) => { e.preventDefault(); setOpen(true); }}>{children}</a>
      {open && (
        <>
          {/* 딤 클릭으로는 닫지 않는다 — 약관을 읽는 중 잘못 눌리면 다시 찾아 열어야 한다 */}
          <div className="layer-backdrop open"></div>
          <div className="layer-popup open">
            <div className="layer-header">
              <h2 className="layer-title">{children}</h2>
              <button className="layer-close" onClick={() => setOpen(false)} aria-label={t('notice.close')}>
                <Icon name="x" />
              </button>
            </div>
            <div className="layer-body">
              <div className="layer-section active">
                {html
                  ? <div dangerouslySetInnerHTML={{ __html: html }} />
                  : <p>{html === undefined ? '' : t('notice.empty')}</p>}
              </div>
            </div>
            <div className="layer-footer">
              <button className="action-btn action-cancel btn-sm" onClick={() => setOpen(false)}>{t('notice.close')}</button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
